import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ProductExportService } from "src/app/views/common/services/product-export.service";

@Component({
  selector: "app-export-field-dialog",
  templateUrl: "./export-field-dialog.component.html",
  styleUrls: ["./export-field-dialog.component.css"],
})
export class ExportFieldDialogComponent implements OnInit {
  @Input() name: any;
  @Input() exportData: any;

  addNew: Boolean = false;
  confirmationDialogService: any;

  uploadedIndex: number;
  constructor(
    private route: Router,
    private activeModal: NgbActiveModal,
    private ProdExportServ: ProductExportService
  ) {}

  fieldForm: FormGroup;

  buildExportDialogForm() {
    this.fieldForm = new FormGroup({
      id: new FormControl(this.exportData.productExportId),
      export_name: new FormControl(
        this.exportData.productExportName,
        Validators.required
      ),
      no_copies: new FormControl(
        this.exportData.no_copies,
        Validators.required
      ),
      product_id: new FormControl(this.exportData.productId),
      template_id: new FormControl(this.exportData.templateFieldId),
      template_price_field_id: new FormControl(
        this.exportData.templatePriceFieldId
      ),
      template_sub_field_id: new FormControl(
        this.exportData.templateSubFieldId
      ),
    });
  }

  ngOnInit() {
    console.log(this.exportData);
    this.buildExportDialogForm();

    if (this.exportData.productExportId == null) {
      this.addNew = true;
    } else {
      this.addNew = false;
      this.exportFieldRecordById(this.exportData.productExportId);
    }
  }

  exportFieldRecordById(export_id) {
    this.ProdExportServ.exportFieldRecordById(export_id).subscribe(
      (res: any) => {
        if (res != null) {
          this.patchValue(res.data);
        }
      }
    );
  }

  patchValue(data) {
    this.fieldForm.patchValue({
      id: data.id,
      export_name: data.export_name,
      no_copies: data.no_copies,
      product_id: this.exportData.productId,
      template_id: this.exportData.templateFieldId,
      template_price_field_id: this.exportData.templatePriceFieldId,
      template_sub_field_id: this.exportData.templateSubFieldId,
      // product_id: data.product_id,
      // template_id: data.template_id,
      // template_price_field_id: data.template_price_field_id,
      // template_sub_field_id: data.template_sub_field_id,
    });
  }

  public reset() {
    this.fieldForm.reset();
  }

  onSubmit(formValues) {
    if (formValues.id == null) {
      this.ProdExportServ.addProductExport(formValues).subscribe((res: any) => {
        // this.route.navigate(["/AdminPanel/product-export"]);
        this.exportData = null;
        this.activeModal.close(true);
      });
    } else {
      this.ProdExportServ.updateProductExport(formValues).subscribe(
        (res: any) => {
          // this.route.navigate(["/AdminPanel/product-export"]);
          this.exportData = null;
          this.activeModal.close(true);
        }
      );
    }
  }

  public dismiss() {
    this.exportData = null;
    this.activeModal.dismiss();
  }
}
